import BasePDFDefinitionColumnBuilder, * as BaseColumnBuilder from "../BasePDFDefinitionColumnBuilder"
import {ReportGroupingLevel} from "../../reports/constants";
import messageResource from '../../messageResource'
import {ColumnsConfig} from "../../reports/overtimeReport/ColumnsConfig";

class PDFDefinitionColumnBuilder extends BasePDFDefinitionColumnBuilder {
    init(config, rowSpanNumber) {
        super.init(config, rowSpanNumber);
        this.reportGroupingValues = ["reportFirstGroupingValue", "reportThirdGroupingValue"];

        return this;
    }
}

export class Levels extends BaseColumnBuilder.Levels {
    init(config, store, rowSpanNumber) {
        PDFDefinitionColumnBuilder.prototype.init.call(this, config, rowSpanNumber);

        this.store = store;
        this.groupingLevels = [config.firstGroupingLevel, config.secondGroupingLevel];
        this.reportGroupingStyles = ["reportFirstGroupingRow", "reportThirdGroupingRow"];
        this.reportGroupingMargins = ["reportFirstGroupingRowMargin", "reportSecondGroupingRowMargin"];

        this.isWide = config.columnsConfig != ColumnsConfig.TIME_BALANCE_AND_OVERTIME;
        this.maxUserNameLen = this.isWide ? "maxUserNameLenWide" : "maxUserNameLen";
        this.showWorkingAndLeaveTime = config.showWorkingAndLeaveTime;
        return this;
    }

    _makeCustomRow(style, groupingLevel, id) {
        var text = this._getTitle(groupingLevel, id, this.params[this.maxUserNameLen]);
        return this._makeRowDefinition(style, text);
    }

    pushWidth(destination, sizes) {
        var baseWidth = this.isWide ? sizes["levelsWide"] : sizes["levels"];
        destination.push(baseWidth + '%');
    }

    makeHeader() {
        var names = [];
        for (var i = 0; i < 2; i++) {
            if (this.groupingLevels[i] != ReportGroupingLevel.NONE) {
                names.push(this.formatUtil.formatGroupingLevel(this.groupingLevels[i]));
            }
        }
        return this._makeHeaderDefinition(names.join(' / '), [this.tableHeaderStyleNoMargin, "reportLevelsTitle"]);
    }

    makeTotals() {
        return this._makeRowDefinition("reportTotal", messageResource.getMessage("report.total"));
    }

    makeRow(lvl, data) {
        return this._makeCustomRow([this.reportGroupingStyles[lvl], this.reportGroupingMargins[lvl]], this.groupingLevels[lvl], data.id);
    }
}


export class TimeBalance extends PDFDefinitionColumnBuilder {
    init(config, rowSpanNumber) {
        super.init(config, rowSpanNumber);
        if (config.columnsConfig == ColumnsConfig.TIME_BALANCE_ONLY) {
            this.sizeName = config.showWorkingAndLeaveTime ? "timeBalance" : "timeBalanceWide";
        } else {
            this.sizeName = config.showWorkingAndLeaveTime ? "timeBalanceAll" : "timeBalance";
        }
        this.showWorkingAndLeaveTime = config.showWorkingAndLeaveTime;
        return this;
    }

    pushWidth(destination, sizes) {
        destination.push(sizes[this.sizeName] + '%');
        destination.push(sizes[this.sizeName] + '%');
        destination.push(sizes[this.sizeName] + '%');

        if (this.showWorkingAndLeaveTime) {
            destination.push(sizes[this.sizeName] + '%');
            destination.push(sizes[this.sizeName] + '%');
        }
    }

    makeHeader() {
        var varianceTxt = messageResource.getMessage("report.overtime.time_balance");

        var header = [
            {
                style: this.tableHeaderStyle,
                text: varianceTxt,
                colSpan: this.showWorkingAndLeaveTime ? 5 : 3
            }, {}, {}
        ];

        if (this.showWorkingAndLeaveTime) {
            header.push({}, {});
        }
        return header;
    }

    makeSubHeader() {
        var subHeader = [
            {
                style: this.tableHeaderStyle,
                text: messageResource.getMessage("report.overtime.time_balance.scheduled")
            },
            {
                style: this.tableHeaderStyle,
                text: messageResource.getMessage("report.overtime.time_balance.reported")
            },
            {
                style: this.tableHeaderStyle,
                text: messageResource.getMessage("report.overtime.time_balance.difference")
            }
        ];

        if (this.showWorkingAndLeaveTime) {
            subHeader.splice(2, 0,
                {
                    style: this.tableHeaderStyle,
                    text: messageResource.getMessage("report.overtime.time_balance.working_time")
                },
                {
                    style: this.tableHeaderStyle,
                    text: messageResource.getMessage("report.overtime.time_balance.leave_time")
                }
            );
            subHeader[1].text = messageResource.getMessage("report.overtime.time_balance.total_reported");
        }

        return subHeader;
    }

    _makeRow(style, data, valueMask) {
        var row = [
            this.makeTimeCell(data.scheduledTime, style),
            this.makeTimeCell(data.reportedTime, style),
            this.makeSignedTimeCell(data.differenceTime, style)
        ];

        if (this.showWorkingAndLeaveTime) {
            row.splice(2, 0,
                this.makeTimeCell(data.workingTime, style),
                this.makeTimeCell(data.leaveTime, style)
            );
        }
        return row;
    }
}

export class Overtime extends PDFDefinitionColumnBuilder {
    init(config, rowSpanNumber) {
        super.init(config, rowSpanNumber);
        this.sizeName = config.columnsConfig == ColumnsConfig.OVERTIME_ONLY ? "overtimeWide" : "overtime";
        this.showWorkingAndLeaveTime = config.showWorkingAndLeaveTime;
        return this;
    }

    pushWidth(destination, sizes) {
        if (this.showWorkingAndLeaveTime) {
            destination.push(sizes["allColumnsOvertimeReported"] + '%');
            destination.push(sizes["allColumnsOvertimeAuto"] + '%');
        } else {
            destination.push(sizes[this.sizeName] + '%');
            destination.push(sizes[this.sizeName] + '%');
        }
    }

    makeHeader() {
        var varianceTxt = messageResource.getMessage("report.overtime.overtime");

        return [
            {
                style: this.tableHeaderStyle,
                text: varianceTxt,
                colSpan: 2
            }, {}
        ];
    }

    makeSubHeader() {
        return [
            {
                noWrap: false,
                style: this.tableHeaderStyle,
                columns: this.addAsterisk(messageResource.getMessage("report.overtime.overtime.reported_by_user"), '*')
            },
            {
                noWrap: false,
                style: this.tableHeaderStyle,
                columns: this.addAsterisk(messageResource.getMessage("report.overtime.overtime.auto_calculated"), '**')
            }
        ];
    }

    _makeRow(style, data, valueMask) {
        var reported = this.makeTimeCell(data.reportedOvertime, style);
        var autocalculated;

        if (data.isEmployed === false) {
            autocalculated = this.makeTextCell(messageResource.getMessage("report.overtime.not_employed"), this.grayText);
        } else {
            autocalculated = this.makeTimeCell(data.autoOvertime, style);
        }

        return [
            reported,
            autocalculated
        ];
    }
}


// WEBPACK FOOTER //
// ./web/js/pdf/overtimeReport/PDFDefinitionColumnBuilder.js